<button type="button"
        class="ace-btn btn-primary has-icon"
        [ngClass]="buttonClass()"
        (click)="showAttachmentsDialog()"
        [disabled]="disabled()"
        wsFileDrop
        (filesDropped)="onFilesDropped($event)">
    <i class="fa {{icon()}}"></i>
</button>

